import { createContext, PropsWithChildren, useContext, useMemo, useState } from 'react';
import { BehaviorSubject } from 'rxjs';

type DatasetsProviderType = {
  uploadPercentages$: BehaviorSubject<Record<string, number>>;
  fileNames$: BehaviorSubject<string[]>;
  open$: BehaviorSubject<boolean>;
};

export const VolumeUploadContext = createContext<DatasetsProviderType>({} as DatasetsProviderType);
export const VolumeUploadProvider = ({ children }: PropsWithChildren) => {
  const [uploadPercentages$] = useState(new BehaviorSubject<Record<string, number>>({}));
  const [fileNames$] = useState(new BehaviorSubject<string[]>([]));
  const [open$] = useState(new BehaviorSubject<boolean>(false));
  const value = useMemo(
    () => ({ uploadPercentages$, fileNames$, open$ }),
    [uploadPercentages$, fileNames$, open$],
  );
  return <VolumeUploadContext.Provider value={value}>{children}</VolumeUploadContext.Provider>;
};

export const useUploadModal = () => useContext(VolumeUploadContext);
